import { companyCodes } from "./constants"

const validationMessages = {
    // SignUp Form
    name: 'Lütfen adınızı giriniz',
    surname: 'Lütfen soyadınızı giriniz',
    companyCode: 'Lütfen şirket kodunu giriniz',
    email: 'Lütfen e-posta adresinizi giriniz',
    regexEmailMatch: 'Lütfen geçerli bir e-posta adresi giriniz',
    password: 'Lütfen şifrenizi en az 6 karakter olarak şekilde giriniz',
    passwordConfirmation: 'Lütfen şifreyi aynı olacak şekilde giriniz',
    
    // Add Product Form
    product: {
        name: 'Lütfen ürün adını doğru giriniz',
        code: 'Lütfen ürün kodunu doğru giriniz',
        image: 'Lütfen ürün resmini 1000 x 1000 boyutunda olacak şekilde giriniz',
    }
};

const regex = {
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    password: /^(?=.*).{6,}$/,
    name: /^(?=.{2,})[a-zA-Z0-9ğüşöçİĞÜŞÖÇ ]+(([',. -][a-zA-Z0-9ğüşöçİĞÜŞÖÇ ])?[a-zA-Z0-9ğüşöçİĞÜŞÖÇ ]*)$/,
    code: /^(?=.*).{3,}$/
};

const { name, 
        surname, 
        companyCode, 
        email, 
        password, 
        passwordConfirmation, 
        regexEmailMatch, 
        product } = validationMessages;

const validationRules = {
    // Login Form
    login: {
        fields: {
            email: {
                pattern: '',
                message: email,
                regexPattern: regex.email,
                regexMessage: regexEmailMatch,
            },
            password: {
                pattern: '',
                message: password,
            },
            companyCode: {
                pattern: companyCodes.oztabak,
                message: companyCode,
            },
        },
    },

    // Signup Form
    signUp: {
        fields: {
            name: {
                pattern: '',
                regexPattern: regex.name,
                regexMessage: name,
            },
            surname: {
                pattern: '',
                regexPattern: regex.name,
                regexMessage: surname,
            },
            email: {
                pattern: '',
                message: email,
                regexPattern: regex.email,
                regexMessage: regexEmailMatch,
            },
            password: {
                pattern: '',
                regexPattern: regex.password,
                regexMessage: password,
            },
            passwordConfirmation: {
                pattern: '',
                message: passwordConfirmation,
            },
            companyCode: {
                pattern: 'oztabak-tr-14-001',
                message: companyCode,
            },
        },
    },

    //Add Product Form
    addProduct: {
        fields: {
            code: {
                pattern: '',
                regexPattern: regex.code,
                regexMessage: product.code,
            },
            name: {
                pattern: '',
                regexPattern: regex.name,
                regexMessage: product.name,
            },
            description: {
                pattern: '',
            }
        },
    },
};

export {
    validationRules
}